import { ArrowUpRight } from "lucide-react";
import SectionBadge from "@/components/site/SectionBadge";
import { track } from "@/lib/analytics";

const GRID = "max-w-7xl mx-auto px-6 sm:px-8 md:px-12";

/**
 * 30-minute Growth Diagnostic offer — a lower-commitment conversion path.
 * Opens the standard enquiry dialog (no fake calendar availability).
 */
export default function DiagnosticOffer({ testid, onRequest }) {
  return (
    <section data-testid={testid} className="py-14 md:py-16 bg-[#F2F2F2]">
      <div className={`${GRID} grid grid-cols-12 gap-8 items-center`}>
        <div className="col-span-12 md:col-span-7 reveal">
          <SectionBadge label="Growth Diagnostic" />
          <h2 className="font-serif-display text-2xl sm:text-3xl lg:text-4xl mt-5 leading-[1.15] max-w-xl">
            Not Sure What's Holding Back Growth?
          </h2>
          <p className="mt-4 text-base text-zinc-600 leading-relaxed max-w-xl">
            Request a focused 30-minute discussion to explore your commercial
            challenges, identify potential growth constraints and determine
            practical next steps.
          </p>
          <button
            data-testid={`${testid}-cta`}
            onClick={() => {
              track("service_cta_click", {
                service: "Growth Diagnostic Call",
                source_page: window.location.pathname,
                cta_location: "growth-diagnostic",
              });
              onRequest();
            }}
            className="group mt-7 inline-flex items-center gap-2 h-12 px-7 bg-black text-white text-sm font-medium hover:bg-zinc-800 transition-colors duration-300"
          >
            Request a Growth Diagnostic Call
            <ArrowUpRight className="h-4 w-4 transition-transform duration-300 group-hover:translate-x-0.5 group-hover:-translate-y-0.5" />
          </button>
        </div>
        <div className="col-span-12 md:col-span-5 reveal">
          <ul className="space-y-4 md:border-l md:border-black/10 md:pl-8">
            {[
              ["Focused 30 minutes", "A working conversation about your situation — not a sales pitch."],
              ["Your commercial challenges", "We explore where growth may be constrained and why."],
              ["Practical next steps", "You leave with a clearer view of what to address first."],
            ].map(([h, b]) => (
              <li key={h}>
                <div className="text-sm font-semibold text-black">{h}</div>
                <div className="text-sm text-zinc-600 mt-0.5 leading-relaxed">{b}</div>
              </li>
            ))}
          </ul>
        </div>
      </div>
    </section>
  );
}
